import React from 'react';
import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Report2025 = () => {
  return (
    <div className={cx('limiter')}>
      <div className={cx('table')}>
        <p className={cx('sub')}>전자공시 - 23기 결산 공고</p>
        <h3 className={cx('title')}>재무상태표</h3>
        <p className={cx('date')}>2025년 12월 31일 (단위: 원)</p>
        <div className={cx('scrollable')}>
          <div className={cx('head')}>
            <ul>
              <li style={{ flex: 1 }}>과목</li>
              <li style={{ flex: 1 }}>제 23(당) 기말</li>
              <li style={{ flex: 1 }}>제 22(전) 기말</li>
            </ul>
          </div>
          <div className={cx('body')}>
            <ul>
              <li>
                <ul>
                  <li className={cx('point')}>자산</li>
                  <li></li>
                  <li></li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>유동자산</li>
                  <li>24,457,938,442</li>
                  <li>43,887,614,990</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>현금및현금성자산</li>
                  <li>1,537,224,521</li>
                  <li>4,781,083,542</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>매출채권및기타채권</li>
                  <li>7,703,639,214</li>
                  <li>8,296,706,102</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>단기투자자산</li>
                  <li>4,083,239,717</li>
                  <li>20,654,845,568</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>재고자산</li>
                  <li>10,779,664,569</li>
                  <li>9,890,349,041</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>기타유동자산</li>
                  <li>354,170,421</li>
                  <li>264,630,737</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>비유동자산</li>
                  <li>101,172,031,964</li>
                  <li>97,721,949,448</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>장기매출채권및기타채권</li>
                  <li>1,732,770,921</li>
                  <li>1,054,500,286</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>유형자산</li>
                  <li>63,467,501,182</li>
                  <li>58,017,129,300</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>무형자산</li>
                  <li>35,790,491,535</li>
                  <li>36,317,301,810</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>이연법인세자산</li>
                  <li>-</li>
                  <li>2,151,348,315</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>기타비유동자산</li>
                  <li>181,268,326</li>
                  <li>181,669,737</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>자산총계</li>
                  <li>125,629,970,406</li>
                  <li>141,609,564,438</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className={cx('point')}>부채및자본</li>
                  <li></li>
                  <li></li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>유동부채</li>
                  <li>18,579,600,628</li>
                  <li>32,699,378,856</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>매입채무및기타채무</li>
                  <li>10,345,640,370</li>
                  <li>11,213,082,091</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>단기차입금</li>
                  <li>6,058,728,000</li>
                  <li>6,240,487,694</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>유동성리스부채</li>
                  <li>1,335,108,015</li>
                  <li>684,896,347</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>당기법인세부채</li>
                  <li>98,900,596</li>
                  <li>1,196,318,131</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>파생금융부채</li>
                  <li>-</li>
                  <li>12,417,573,759</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>기타유동부채</li>
                  <li>708,209,047</li>
                  <li>824,564,841</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>기타유동충당부채</li>
                  <li>33,014,600</li>
                  <li>122,455,993</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>비유동부채</li>
                  <li>12,824,802,557</li>
                  <li>15,546,344,499</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>장기차입금</li>
                  <li>1,337,328,000</li>
                  <li>2,271,056,000</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>장기리스부채</li>
                  <li>765,130,366</li>
                  <li>691,359,231</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>순확정급여부채</li>
                  <li>8,258,186,179</li>
                  <li>7,533,022,223</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>이연법인세부채</li>
                  <li>2,342,059,236</li>
                  <li>4,936,124,723</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>기타비유동충당부채</li>
                  <li>122,098,776</li>
                  <li>114,782,322</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>부채총계</li>
                  <li>31,404,403,185</li>
                  <li>48,245,723,355</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>자본금</li>
                  <li>11,012,460,000</li>
                  <li>11,012,460,000</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>기타불입자본</li>
                  <li>52,407,766,754</li>
                  <li>52,407,766,754</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>이익잉여금</li>
                  <li>30,805,340,467</li>
                  <li>29,943,614,329</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>자본총계</li>
                  <li>94,225,567,221</li>
                  <li>93,363,841,083</li>
                </ul>
              </li>
              <li>
                <ul>
                  <li>부채및자본총계</li>
                  <li>125,629,970,406</li>
                  <li>141,609,564,438</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={cx('inner')}>
        <div className={cx('ann')}>
          <p>위와 같이 공고함</p>
          <ul>
            <li>2026년 3월 31일</li>
            <li>풀무원샘물 주식회사</li>
            <li>대표이사 백동옥</li>
          </ul>
        </div>
        <div className={cx('text')}>
          <p>
            감사의견 : 우리의 의견으로는 회사의 재무제표는 2025년 12월 31일 현재의 재무상태, 동일로 종료되는 보고기간의 재무성과 및
            현금흐름을 한국채택국제회계기준에 따라 중요성의 관점에서 공정하게 표시하고 있습니다.
            <span>삼일회계법인 대표이사 김교태</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Report2025;
